import { createContext, useState, useRef, useContext } from 'react';

const AppContext = createContext({
	code: '', 
	setCode: () => {},
	isVisible: true, 
	setIsVisible: () => {},
	galleryContainerRef: { current: null },
	modalImageIndex: 0,
});

export const AppProvider = ({ children, config, psServer}) => {

	const [showSearchBox, setShowSearchBox] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [showTerms, setShowTerms] = useState(false);
	const [GDPRDaysLeft, setGDPRDaysLeft] = useState(0);
	
	const paymentGateway = config.paymentGateway ? config.paymentGateway : '';
	const paymentAppID = config.paymentAppID ? config.paymentAppID : '';
	const [gatewayResponse, setGatewayResponse] = useState(null);
	
	const onlineOnly = config.onlineOnly === "Y";
	const showCookie = config.showCookie === "Y";
	
	const locationId = config.locationId ? config.locationId : '';
	
	const fullfilment = config.fullfilment ? config.fullfilment : '';
	
	const countryCode = config.countryCode ? config.countryCode : '';
	const currencyCode = config.currency ? config.currency : '';
	const currencySymbol = () => {
		const currency = config.currency ? config.currency : '';
		switch (currency) {
			case "USD":
				return '$';
			case "GBP":
			default:
				return '£';
		}
	};
	const codeFormat = config.codeFormat ? config.codeFormat : '';
	const startsWithMessage = config.startsWithMessage ? config.startsWithMessage : '';
	
	const [qrCodeValue, setQrCodeValue] = useState(null);
	const [codeFailed, setCodeFailed] = useState(0);
	const [code, setCode] = useState('');
	const [isVisible, setIsVisible] = useState(true);
	const [submittedCode, setSubmittedCode] = useState(null);
	
	const [showTermsPopup, setShowTermsPopup] = useState(false);

	const [showModal, setShowModal] = useState(null);
	const [modalImageIndex, setModalImageIndex] = useState(null);

	const galleryContainerRef = useRef(null);
	const [gallery, setGallery] = useState(null);
	const [fullCodeData, setFullCodeData] = useState(null);
	const [allowPurchase, setAllowPurchase] = useState(false);
	const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
	const [clickedImage, setClickedImage] = useState(null);

	const [startDownloadInd, setStartDownloadInd] = useState(null);
	const [startDownloadAll, setStartDownloadAll] = useState(null);

	const [packageChoice, setPackageChoice] = useState([]);
    const [selectedItems, setSelectedItems] = useState({ prints: {}, keyrings: {} });
	
	const [email, setEmail] = useState('');
	
	const [addressDetails, setAddressDetails] = useState({
		firstName: '',
		lastName: '',
		addressLine1: '',
		addressLine2: '',
		townCity: '',
		county: '',
		postcode: '',
	});
	
	const [paymentID, setPaymentID] = useState('');
	const [paymentSuccess, setPaymentSuccess] = useState(false);
	
	return (
		<AppContext.Provider value={{ psServer, onlineOnly, showCookie, isLoading, setIsLoading, showSearchBox, setShowSearchBox, showTerms, setShowTerms, GDPRDaysLeft, setGDPRDaysLeft,
			paymentGateway, paymentAppID, locationId, gatewayResponse, setGatewayResponse,
			fullfilment, countryCode, currencyCode, currencySymbol, codeFormat, startsWithMessage,
			qrCodeValue, setQrCodeValue,
			codeFailed, setCodeFailed,
			code, setCode,
			isVisible, setIsVisible,
			submittedCode, setSubmittedCode,
			showTermsPopup, setShowTermsPopup,
			showModal, setShowModal, modalImageIndex, setModalImageIndex,
			galleryContainerRef,
			gallery, setGallery,
			fullCodeData, setFullCodeData,
			allowPurchase, setAllowPurchase,
			isConfirmDialogOpen, setIsConfirmDialogOpen,
			setClickedImage, clickedImage,
			startDownloadInd, setStartDownloadInd, startDownloadAll, setStartDownloadAll,
			packageChoice, setPackageChoice, selectedItems, setSelectedItems,
			email, setEmail,
			addressDetails, setAddressDetails,
			paymentID, setPaymentID,
			paymentSuccess, setPaymentSuccess}}
		>
			{children}
		</AppContext.Provider>
	);
};

export const useAppContext = () => {
	return useContext(AppContext);
};

export default AppContext;